require("./dist/angular-ui-notification.css");
module.exports = require("./dist/angular-ui-notification.js");


/*****************
 ** WEBPACK FOOTER
 ** angular-ui-notification (bower component)
 ** module id = 375
 ** module chunks = 1
 **/